import React from "react";
import Close from "../../../Assets/img/Group 2312.svg";

function HintPack() {
  return (
    <div className="hintpack">
      <a className="first-notification close" href="/">
        <img src={Close} alt="" />
      </a>
      <div className="hintpack-body">
        <div class="row">
          <div class="col-lg-7 mx-auto price-title">
            <h1>Pick your hints pack Champ</h1>
          </div>
        </div>
        <div class="row text-center d-flex justify-content-center mt-4 pt-2">
          <div class="col-lg-3 mb-lg-0 mr-5">
            <div class="price-card bg-white p-3 rounded-lg shadow bg-background text-center">
              <h1 class="h6 text-uppercase font-weight-bold mb-1 mt-2">
                uno pack
              </h1>

              <div class="custom-separator my-3 mx-auto bg-primary"></div>

              <ul class="list-unstyled text-small text-left text-center">
                <li className="mb-2">1 hint</li>
                <li className="mb-2">Can be used in any Level</li>
              </ul>
              <a
                href="/cart"
                class="btn btn-yellow btn-block p-2 mt-4 shadow text-center ml-auto mr-auto"
              >
                $1.99
              </a>
            </div>
          </div>
          <div class="col-lg-3 mb-lg-0">
            <div class="price-card bg-white p-3 rounded-lg shadow bg-background text-center">
              <h1 class="h6 text-uppercase font-weight-bold mb-1 mt-2">
                Duo pack
              </h1>

              <div class="custom-separator my-3 mx-auto bg-primary"></div>

              <ul class="list-unstyled text-small text-left text-center">
                <li className="mb-2">2 hint</li>
                <li className="mb-2">Can be used in any Level</li>
              </ul>
              <a
                href="/cart"
                class="btn btn-yellow btn-block p-2 mt-4 shadow text-center ml-auto mr-auto"
              >
                $2.49
              </a>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}

export default HintPack;
